import React from "react";
import {img} from "@/utils/pluginImg.js";

// Ported from plugin customComponent/prebookCompare.jsx

// hopn-side advantages (left column of the comparison)
const HOPN_FEATURES = [
    {icon: "good-shild.svg", title: "Guaranteed pickup", sub: "0 missed pickups last 12 months"},
    {icon: "big-lock.svg", title: "Flat fare – no surprise", sub: "What you see what you pay"},
    {icon: "plane.svg", title: "Unlimited airport waiting", sub: ""},
    {icon: "luggageAssistance.svg", title: "Luggage assistance", sub: "Door to terminal by driver"},
    {icon: "clientSeats.svg", title: "Free child car seats", sub: ""},
];

// Ride-share shortcomings (right column)
const SHARE_FEATURES = [
    "Pickup not guaranteed",
    "Prices change with demand",
    "Limited waiting time",
    "Self luggage handling",
    "Unavailable",
];

const RedX = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8.25" stroke="#E0524A" strokeWidth="1.2"/>
        <path d="M6.2 6.2l5.6 5.6M11.8 6.2l-5.6 5.6" stroke="#E0524A" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
);

function CompareHeader({pickup, dropoff, price, sharePrice}) {
    return (
        <>
            <div className="pc-head">
                <strong>Prebook vs Ride-Sharing</strong>
                <small>{pickup} → {dropoff}</small>
            </div>
            <div className="pc-cards">
                <div className="pc-card hopn">
                    <span className="pc-car"><img src={img("compare-hopn-car.svg")} alt=""/></span>
                    <div className="pc-card-info">
                        <img className="pc-logo" src={img("logo-latest.svg")} alt="hopn" width="40"/>
                        <span className="amt">${price}</span>
                        <small className="muted">BLACK · SUV · EXECUTIVE</small>
                    </div>
                </div>
                <span className="pc-vs">VS</span>
                <div className="pc-card share">
                    <span className="pc-car"><img src={img("compare-share-car.svg")} alt=""/></span>
                    <div className="pc-card-info">
                        <small>Ride-share</small>
                        <span className="amt">${sharePrice}</span>
                        <small className="muted">May vary with surge</small>
                    </div>
                </div>
            </div>
        </>
    );
}

// View 1 — Prebook vs Ride-Sharing comparison detail.
// The "Exclusive Airport Pickup Perks → More" bar lives in the modal footer
// (see selectedCarDetailsLatest), not here.
export function PrebookCompareDetail({pickup, dropoff, price, sharePrice}) {
    return (
        <div className="prebook-compare">
            <CompareHeader pickup={pickup} dropoff={dropoff} price={price} sharePrice={sharePrice}/>

            <div className="pc-compare-cols">
                <ul className="pc-col hopn">
                    {HOPN_FEATURES.map((f, i) => (
                        <li key={i}>
                            <span className="ic"><img src={img(f.icon)} alt=""/></span>
                            <span className="txt">
                                <strong>{f.title}</strong>
                                {f.sub && <small>{f.sub}</small>}
                            </span>
                        </li>
                    ))}
                </ul>
                <ul className="pc-col share">
                    {SHARE_FEATURES.map((t, i) => (
                        <li key={i}>
                            <span className="ic"><RedX/></span>
                            <span className="txt"><strong>{t}</strong></span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
